import { Link as ChakraLink } from "@chakra-ui/react";
import { HTMLChakraProps } from "@chakra-ui/react/dist/types/system";
import { Link as ReactRouterLink } from "react-router-dom";

export const Link = ({
  to,
  children,
  ...rest
}: {
  to: string;
  children: string;
} & HTMLChakraProps<"a">) => {
  return (
    <ChakraLink as={ReactRouterLink} to={to} color="primary.500" {...rest}>
      {children}
    </ChakraLink>
  );
};
